import type { LevelConfig } from './levels';
import type { Platform } from './state';
export function createRiver(config: LevelConfig): Platform[] {
  return config.water.flatMap(l => Array.from({length:l.count}, (_,i) => {
    const x = l.offset + i*l.period/l.count;
    const sequence = i+1;
    const kind = l.crocEvery && sequence % l.crocEvery === 0 ? 'crocodile' : l.kind;
    return { id:`water-${l.lane}-${i}`, x, previousX:x, dx:0,y:l.y,w:l.width,speed:l.speed,
      period:l.period,wrapped:false,cycle:0,lane:l.lane,kind,baseKind:l.kind, sequence,
      diving:l.diving && i===0,phaseOffset:l.lane===4 ? 90 : 0,divePeriod:l.divePeriod };
  }));
}
export function updatePlatformKind(p: Platform, config: LevelConfig): void {
  if (!p.wrapped) return;
  const l = config.water[p.lane-1]!;
  p.sequence += l.count;
  p.kind = l.crocEvery && p.sequence % l.crocEvery === 0 ? 'crocodile' : p.baseKind;
}
